module.exports = __webpack_public_path__ + "static/media/sh.2469dbfa.svg";